import { IMessageContentTypeBubble } from "../../MessagePanel";
import { MESSAGE_STATUS } from "@home-health-notify/domain";
import VideoContentItem from "./VideoContentItem";

const VideoContent = ({
  message,
  openMediaDialog,
}: IMessageContentTypeBubble) => {
  let messageData = message.getMessage();
  const isPendingMessage = messageData.status === MESSAGE_STATUS.PENDING;

  return (
    <>
      {(messageData.videos ?? []).map((videoMessage, i) => (
        <VideoContentItem
          key={videoMessage.url + i}
          videoMessage={videoMessage}
          isPendingMessage={isPendingMessage}
          onOpenPreview={() => {
            if (!isPendingMessage && openMediaDialog) {
              openMediaDialog(message);
            }
          }}
        />
      ))}
    </>
  );
};

export default VideoContent;
